import { ADMIN_ROLE } from "src/services/auth";
import useRestricted from "src/app/Restricted/useRestricted";
import useUserRole from "src/app/Restricted/useUserRole";
import useDefaultRoutePath from "src/app/Restricted/useDefaultRoutePath";
import useShowInvite from "src/components/InviteUser/hooks/useShowInvite";
import { useWorkspace } from "src/contexts/global/WorkspaceContext";

export type Auth0UserOrStub =
  | import("src/services/auth").Auth0User
  | import("src/services/auth").AuthStub;

type UseSidebarUserContextArgs = {
  user: Auth0UserOrStub;
  workspace: ReturnType<typeof useWorkspace>;
};

/**
 * Bundles the sidebar's user/role/route hooks (restriction level, admin
 * status, default route, and invite visibility) into one flat result.
 */
const useSidebarUserContext = ({
  user,
  workspace,
}: UseSidebarUserContextArgs) => {
  const [isRestricted, isPartiallyRestricted] = useRestricted();
  const isAdmin = useUserRole() === ADMIN_ROLE;
  const defaultRoutePath = useDefaultRoutePath();
  const shouldShowInvite = useShowInvite({ workspace, user });

  return {
    isRestricted,
    isPartiallyRestricted,
    isAdmin,
    defaultRoutePath,
    shouldShowInvite,
  };
};

export default useSidebarUserContext;
